import {
  FETCH_DATA_ROOMLIST_REQUEST,
  FETCH_DATA_ROOMLIST_SUCCESS,
  FETCH_DATA_ROOMLIST_FAILURE,
  SAVE_DATA_ROOMLIST_REQUEST,
  SAVE_DATA_ROOMLIST_SUCCESS
} from "./constants";

import { IBookingSite } from "../../../models";

export const fetchRoomListRequest = (payload: IBookingSite) => ({
  type: FETCH_DATA_ROOMLIST_REQUEST,
  payload
});

export const fetchRoomListSuccess = (payload: IBookingSite) => ({
  type: FETCH_DATA_ROOMLIST_SUCCESS,
  payload
});

export const fetchRoomListFailure = (error: string) => ({
  type: FETCH_DATA_ROOMLIST_FAILURE,
  payload: { error }
});

export const saveDataRoomListRequest = (payload: IBookingSite) => ({
  type: SAVE_DATA_ROOMLIST_REQUEST,
  payload
});

export const saveDataRoomListSuccess = (payload: IBookingSite) => ({
  type: SAVE_DATA_ROOMLIST_SUCCESS,
  payload
});
